"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveFeaturedTopics = exports.removeMember = exports.generateInviteToken = exports.fetchUsers = exports.fetchMembersFilters = exports.fetchMembers = exports.declineApplication = exports.approveApplication = exports.addMembers = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var fetchMembersFilters;
exports.fetchMembersFilters = fetchMembersFilters;

(function (fetchMembersFilters) {
  fetchMembersFilters["Applicants"] = "applicants";
  fetchMembersFilters["Moderators"] = "moderators";
})(fetchMembersFilters || (exports.fetchMembersFilters = fetchMembersFilters = {}));

var fetchMembers = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(options) {
    var query, search, filter, response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = "page=".concat(options.page, "&size=").concat(options.pageSize);
            search = options.searchString ? "&search=".concat(options.searchString) : '';
            filter = options.filter ? "&filter=".concat(options.filter) : '';
            _context.next = 5;
            return _axios.default.get("/groups/".concat(options.groupId, "/members?").concat(query).concat(search).concat(filter));

          case 5:
            response = _context.sent;
            return _context.abrupt("return", {
              members: response.data.members,
              total: response.data.total
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchMembers(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchMembers = fetchMembers;

var fetchUsers = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(url, responseKey) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _axios.default.get(url).then(function (response) {
              return responseKey ? response.data[responseKey] : response.data;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchUsers(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.fetchUsers = fetchUsers;

var generateInviteToken = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(payload) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _axios.default.post("/groups/".concat(payload.groupId, "/generate-invite-token"), {
              expiryInDays: payload.expiry
            }).then(function (response) {
              return response.data.token;
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function generateInviteToken(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

exports.generateInviteToken = generateInviteToken;

var addMembers = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(payload) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _axios.default.post("/groups/".concat(payload.groupId, "/moderation/addMembers"), payload.data);

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function addMembers(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

exports.addMembers = addMembers;

var removeMember = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(payload) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _axios.default.post("/groups/".concat(payload.groupId, "/moderation/removeMembers"), payload.data);

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function removeMember(_x6) {
    return _ref5.apply(this, arguments);
  };
}();

exports.removeMember = removeMember;

var saveFeaturedTopics = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(payload) {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _axios.default.post("/groups/".concat(payload.groupId, "/featured-topics"), payload.data);

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function saveFeaturedTopics(_x7) {
    return _ref6.apply(this, arguments);
  };
}();

exports.saveFeaturedTopics = saveFeaturedTopics;

var declineApplication = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(payload) {
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _axios.default.post("/groups/".concat(payload.groupId, "/moderation/declineApplication/").concat(payload.userId));

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function declineApplication(_x8) {
    return _ref7.apply(this, arguments);
  };
}();

exports.declineApplication = declineApplication;

var approveApplication = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(payload) {
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _axios.default.post("/groups/".concat(payload.groupId, "/moderation/approveApplication/").concat(payload.userId));

          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function approveApplication(_x9) {
    return _ref8.apply(this, arguments);
  };
}();

exports.approveApplication = approveApplication;